import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import RichContent from '../components/RichContent';
import ShareButton from '../components/ShareButton';
import { useAuth } from '../context/AuthContext';

export default function NoteDetail() {
  const { slug } = useParams();
  const { token } = useAuth();   // administratrice connectée : brouillons visibles + bouton « modifier »
  const [note, setNote] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    setNote(null); setError(null);
    fetch(`/api/notes/${slug}`, { headers: token ? { Authorization: `Bearer ${token}` } : {} }).then(r => {
      if (!r.ok) throw new Error('Note introuvable');
      return r.json();
    }).then(setNote).catch(e => setError(e.message));
  }, [slug, token]);

  if (error) return <div className="article-detail"><h1>Oups.</h1><p>{error}</p><Link to="/notes" className="btn">← retour</Link></div>;
  if (!note) return <div className="article-detail">chargement...</div>;

  const others = note.siblings.filter(s => s.slug !== note.slug);
  return (
    <article className="article-detail fade-in">
      <Link to={`/notes/sujet/${note.subject_id}`} style={{ fontFamily: 'var(--font-mono)', fontSize: '.85rem', textDecoration: 'underline' }}>← {note.subject_name}</Link>
      <div className="date" style={{ marginTop: '2rem' }}>{note.subject_name}{note.published ? '' : ' · brouillon (visible par vous seule)'}</div>
      <h1>{note.title}</h1>
      <div className="share-row">
        <ShareButton title={note.title} text={note.title} />
        {token && <Link to={`/admin/notes/${note.id}`} className="btn secondary note-edit">modifier</Link>}
      </div>
      <RichContent className="content" html={note.content} />
      {others.length > 0 && (
        <aside className="note-more">
          <h3>Autres dissertations · {note.subject_name}</h3>
          <ul>{others.map(o => <li key={o.slug}><Link to={`/notes/${o.slug}`}>{o.title}</Link></li>)}</ul>
        </aside>
      )}
      <div className="share-end">
        <p>Cette note vous a servi ? Faites-la circuler ✦</p>
        <ShareButton title={note.title} text={note.title} label="partager la note" />
      </div>
    </article>
  );
}
